module.exports = require('./helpers/bundle-url').getBundleURL('5E64i') + "logo.c51670a8.svg";